import botSessionService from '../../api/botsession'
const state = {
  sessions: [],
  activesessions: 0,
  completedsessions: 0,
  messages: [],
  contactcentersessions: 0,
  payinsurancesessions: 0,
  contactcenterrecords: [],
  payinsurancerecords: [],
  referencesessions: 0,
  referencerecords: []
}

const mutations = {
  setSessions (state, sessions) {
    state.sessions = sessions
  },
  setActiveSessions (state, active) {
    state.activesessions = active
  },
  setCompletedSessions (state, completed) {
    state.completedsessions = completed
  },
  setSessionMessages (state, messages) {
    state.messages = messages
  },
  setContactCenterSessions (state, count) {
    state.contactcentersessions = count
  },
  setPayInsuranceSessions (state, count) {
    state.payinsurancesessions = count
  },
  setPayInsuranceSessionsRecords (state, records) {
    state.payinsurancerecords = records
  },
  setContactCenterSessionsRecords (state, records) {
    state.contactcenterrecords = records
  },
  setReferenceSessionsRecords (state, records) {
    state.referencerecords = records
  },
  setReferenceSessions (state, count) {
    state.referencesessions = count
  }
}

const actions = {
  getSessions ({ commit }) {
    botSessionService.getSessions().then(response => {
      commit('setSessions', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getActiveSessions ({ commit }, id) {
    botSessionService.getNoOfActiveSessions(id).then(response => {
      commit('setActiveSessions', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getCompletedSessions ({ commit }, id) {
    botSessionService.getNoOfCompletedSessions(id).then(response => {
      commit('setCompletedSessions', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getSessionMessages ({ commit }, sessionId) {
    botSessionService.getSessionMessages(sessionId).then(response => {
      commit('setSessionMessages', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getContactCustomerCare ({ commit }) {
    botSessionService.getContactCustomerCare().then(response => {
      commit('setContactCenterSessions', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getPayForInsurance ({ commit, dispatch }) {
    botSessionService.getPayForInsurance().then(response => {
      commit('setPayInsuranceSessions', response.data)
    }).catch(error => {
      console.log(error)
      dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.status + error.response.data.message : 'Error ocurred' }, { root: true })
    })
  },
  getPayForInsuranceRecords ({ commit, dispatch }) {
    botSessionService.getPayForInsuranceRecords().then(response => {
      commit('setPayInsuranceSessionsRecords', response.data)
    }).catch(error => {
      console.log(error)
      dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.status + error.response.data.message : 'Error ocurred' }, { root: true })
    })
  },
  getContactCustomerCareRecords ({ commit, dispatch }) {
    botSessionService.getContactCustomerCareRecords().then(response => {
      commit('setContactCenterSessionsRecords', response.data)
    }).catch(error => {
      console.log(error)
      dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.status + error.response.data.message : 'Error ocurred' }, { root: true })
    })
  },
  getReferenceTransactions ({ commit }) {
    botSessionService.getReferenceTransactions().then(response => {
      commit('setReferenceSessions', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getReferenceRecords ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      botSessionService.getReferenceRecords(payload).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  downloadReferenceRecords ({ commit }) {
    return new Promise((resolve, reject) => {
      botSessionService.downloadReferenceRecords().then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStickerRecords ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      botSessionService.getStickerRecords(payload).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
